/**
* 系统管理 用户管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>广告管理</el-breadcrumb-item>
    </el-breadcrumb>


    <div style="margin-top: 20px;display: flex">

      <div style="width: 300px;height: 300px;margin: 20px" @click="firstClick(userData)">
        <el-image style="width: 300px;height: 300px" :src="userData.first"></el-image>
      </div>
      <div style="width: 300px;height: 300px;margin: 20px" @click="secondClick(userData)">
        <el-image style="width: 300px;height: 300px" :src="userData.second"></el-image>

      </div>
      <div style="width: 300px;height: 300px;margin: 20px" @click="thirdClick(userData)">
        <el-image style="width: 300px;height: 300px" :src="userData.third"></el-image>
      </div>

      <el-dialog title="修改" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
        <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
          <el-form-item label="上传照片" prop="avatarUrl">

            <el-upload
              class="avatar-uploader"
              action="/api/tool/ossUpload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess">
              <img v-if="editForm.first" :src="editForm.first" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
          </el-button>
        </div>
      </el-dialog>

      <el-dialog title="修改" :visible.sync="editFormVisible1" width="30%" @click='closeDialog("edit1")'>
        <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
          <el-form-item label="上传照片" prop="avatarUrl">

            <el-upload
              class="avatar-uploader"
              action="/api/tool/ossUpload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess1">
              <img v-if="editForm.second" :src="editForm.second" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click='closeDialog("edit1")'>取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
          </el-button>
        </div>
      </el-dialog>

      <el-dialog title="修改" :visible.sync="editFormVisible2" width="30%" @click='closeDialog("edit2")'>
        <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
          <el-form-item label="上传照片" prop="avatarUrl">

            <el-upload
              class="avatar-uploader"
              action="/api/tool/ossUpload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess2">
              <img v-if="editForm.third" :src="editForm.third" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click='closeDialog("edit2")'>取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
          </el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
// 导入请求方法
import {
  advertisement,
  updateVehicle,
  advertisementUpdate,
  delectVehicle,
  vehicleManagement, selectAllManage,
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {pcaTextArr} from "element-china-area-data";

export default {
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      editFormVisible: false,
      editFormVisible1: false,
      editFormVisible2: false,

      // 编辑与添加
      editForm: {
        id: '',
        first: '',
        second: '',
        third: '',

      },


      // rules表单验证
      rules: {
        brand: [
          {required: true, message: '请输入车辆品牌', trigger: 'blur'},
          {
            validator: function (rule, value, callback) {
              //校验中文的正则：/^[\u4e00-\u9fa5]{0,}$/
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error("请输入中文"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        vehiclemodel: [
          {required: true, message: '请输入车辆型号', trigger: 'blur'}
        ],
        licenseplate: [
          {required: true, message: '请输入车牌号', trigger: 'blur'}
        ],
        colour: [
          {required: true, message: '请输入车辆颜色', trigger: 'blur'}
        ],
        energyType: [
          {required: true, message: '请选择能源种类', trigger: 'blur'}
        ],
        seats: [
          {required: true, message: '请选择座位类型', trigger: 'blur'}
        ],
        belongIdentify: [
          {required: true, message: '请选择所属分部', trigger: 'blur'}
        ],
        lineFixId: [
          {required: true, message: '请选择隶属线路', trigger: 'blur'}
        ],
        inspectionTime: [
          {required: true, message: '请选择年审时间', trigger: 'blur'}
        ],
        // userSex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },

      // 请求数据参数
      formInline: {
        limit: 1,
        page: 10,
        brand: '',
        fixId: '',
        lineFixId: '',
        identify: '',
        isAssociation: '',
        licenseplate: '',

      },
      //用户数据
      userData: {},
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {


    handleAvatarSuccess(res, file) {
      console.log('this.dialogImageUrl', res)
      console.log('file----', res.data.url)
      this.editForm.first = res.data.url;
    },
    handleAvatarSuccess1(res, file) {
      console.log('this.dialogImageUrl', res)
      console.log('file----', res.data.url)
      this.editForm.second = res.data.url;
    },
    handleAvatarSuccess2(res, file) {
      console.log('this.dialogImageUrl', res)
      console.log('file----', res.data.url)
      this.editForm.third = res.data.url;
    },
    firstClick(userDate) {
      this.editFormVisible = true;
      this.editForm.id = userDate.id;
    },
    secondClick(userDate) {
      this.editFormVisible1 = true;
      this.editForm.id = userDate.id;
    },
    thirdClick(){
      this.editFormVisible2 = true;
      this.editForm.id = userDate.id;
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // 获取用户列表
      console.log('parameter', parameter);
      advertisement(parameter).then(res => {
        this.loading = false
        console.log('res---', res)
        if (res.status == 200) {
          this.userData = res.data;

        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.isUpdate == false) {
            // 请求方法
            advertisementUpdate(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.editFormVisible1 = false
                this.editFormVisible2 = false

                this.loading = false
                if (res.status == 200) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            advertisementUpdate(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                this.isUpdate = false;
                console.log('res+++++', res);
                if (res.status == 200) {
                  this.$message({
                    type: 'success',
                    message: '修改成功！'
                  })
                  this.getdata(this.formInline)

                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          }

        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'edit1') {
        this.editFormVisible1 = false
      } else if (dialog == 'edit2') {
        this.editFormVisible2 = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    // 删除用户
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delectVehicle(row.id)
            .then(res => {
              if (res.status == 200) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                if (this.pageparm.total <= 11) {
                  this.formInline.limit = 1;
                }
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 188px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}

.el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 188px;
  height: 148px;
  margin: 0 8px 8px 0;
  display: inline-block;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 178px;
  height: 178px;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  object-fit: cover;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  object-fit: cover;
}
</style>




// WEBPACK FOOTER //
// src/views/system/infomercial.vue